﻿import { AfterViewInit, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CONSTANTS } from "../../config";
import {
  Errors,
  LocalService,
  ManagerService,
  SellerService,
} from "../../core";
import { PopupMessageService } from "../../shared/message/services/message.service";
import { MatPaginatorIntl } from "@angular/material";
import * as geoIdData from "../../../assets/dataGeoId.json";
import { CustomPaginator } from "src/app/config/CustomPaginatorConfiguration";

@Component({
  selector: "app-rewards",
  templateUrl: "./rewards.component.html",
  styleUrls: ["./rewards.component.scss"],
  providers: [
    { provide: MatPaginatorIntl, useFactory: () => CustomPaginator() },
  ],
})
export class RewardsComponent implements OnInit, AfterViewInit {
  errors: Errors = { errors: {} };
  errorMessage =
    "There is a problem connecting to GRS Storefront. Please try again or contact support.";
  userPoints: any;
  userCredits: any;
  pointsUrl: any;
  creditsUrl: any;
  redeemCredits: boolean = false;
  redeemIncentives: boolean = true;
  userProfile: any;
  months = CONSTANTS.months;
  pointsButton: boolean = true;
  creditsButton: boolean = true;
  disableRedeemTicket: boolean = false;
  disableText: boolean = false;
  koreanText: boolean = false;
  userGeoId: any;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 300];
  lang: string = '';
  ticketRedemptionData: any;
  cashEarnedData: any = [];
  pviEligible: boolean = false;

  constructor(
    private sellerService: SellerService,
    private popupMessageService: PopupMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private managerService: ManagerService,
  ) {}

  ngOnInit() {
    this.lang = localStorage.getItem("selectedLanguage") || '';
    this.userProfile = LocalService.get("userProfile");
      if((this.userProfile.hasOwnProperty('userType')&&this.userProfile.userType=='PAM')){
        let pamDataObj;
      pamDataObj= LocalService.get('pamData');
        const beGeoIds0 = pamDataObj.pamBeGeoIdsDTO ? pamDataObj.pamBeGeoIdsDTO.beGeoIds : pamDataObj.beGeoIds;
        const firstGeo0 = (beGeoIds0.content && beGeoIds0.content.length > 0)
          ? beGeoIds0.content[0]
          : (beGeoIds0.length > 0 ? beGeoIds0[0] : null);
        if(firstGeo0 && firstGeo0.companyEligibleChallengesDTO && firstGeo0.companyEligibleChallengesDTO.pvieligible===false){
        this.pviEligible=true;
       }
    }

    this.getPointsAvailable();
    this.getCreditsAvailable();

    this.getCashearnedData();
        if (
          (this.userProfile.pvieligible === false) ||
          (this.userProfile.companyEligibleChallengesDTO &&
            (this.userProfile.companyEligibleChallengesDTO.pvieligible === false))
        ) {
      this.pviEligible=true;
    }
  }

  closePicker(picker: any) {
    picker.open();
  }

  // Check for the company theater name
  checkCompany() {
    return this.userProfile.company.theater &&
      this.userProfile.company.theater.name === "EMEAR"
      ? "true"
      : "false";
  }

  // Get the number of points to redeem for users.
  getPointsAvailable() {
    this.sellerService.getPointsAvailable().subscribe(
      (data: any) => {
        this.pointsButton = true;
        this.userPoints = data;
        if (data && data.pointsRemaining >= 0) {
          this.pointsButton = false;
        }
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  // Get number of tickets to redeem for users.
  getCreditsAvailable() {
    this.sellerService.getCreditsAvailable().subscribe(
      (data: any) => {
        this.userCredits = data;
        this.disableRedeemTicket = data && data.creditsRemaining ? false : true;
        this.userGeoId = this.userProfile.company.beGeoId;
        if (geoIdData.KoreanGeoId.includes(Number(this.userGeoId))) {
          this.disableRedeemTicket = false;
          this.koreanText = false;
        }

        if (this.userProfile.company.region == "EMEAR") {
          const d = new Date().getTime();
          const j = new Date("July 01, 2020 00:00:00").getTime();
          if (j < d) {
            this.disableText = true;
            this.disableRedeemTicket = true;
          }
        }
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }
  // Get the url for points redemption.
  inValidTaxInfoModalOpen = false;

  closeInValidTaxInfoModal() {
    this.inValidTaxInfoModalOpen = false;
  }

  getPointsGrsUrlForUser() {
    this.pointsButton = true;
    let reqParams = "";
    if (
      this.userProfile.hasOwnProperty("userType") &&
      this.userProfile.userType == "PAM"
    ) {
      const pamdata = LocalService.get("pamData");
      const pamBeGeoIds = pamdata.pamBeGeoIdsDTO.beGeoIds;
      const selectedCompanyBeGeoId = pamBeGeoIds.content && pamBeGeoIds.content.length > 0
        ? pamBeGeoIds.content[0].beGeoId
        : pamBeGeoIds[0].beGeoId;
      reqParams =
        "?" +
        "selectedCompanyBeGeoId=" +
        selectedCompanyBeGeoId +
        "&selectedCountryGroup=" +
        pamdata.countryGroup;
    }
    this.sellerService.getPointsGrsUrlForUser(reqParams).subscribe(
      (data: any) => {
        if (data != "") {
          this.pointsButton = false;
          this.pointsUrl = data;
          window.open(this.pointsUrl.url, "_blank");
        }
      },
      (err: any) => {
        console.log(err);
        this.pointsButton = false;
        if (err.invalidTaxInfo === true) {
          this.inValidTaxInfoModalOpen = true;
        }
        this.errors = err;
        if (err.status && err.status === "500 - INTERNAL_SERVER_ERROR") {
          this.popupMessageService.showError(this.errorMessage, "error");
        }
        if (err.status && err.status === "412 - PRECONDITION_FAILED") {
          this.popupMessageService.showError(err.msg, "error");
        }
      }
    );
  }
  prizeDrawingModalOpen = false;
  selectedTicket: any;

  closePrizeDrawingModal() {
    this.prizeDrawingModalOpen = false;
    this.selectedTicket = null;
  }

  //  on Ticket Details
  onTicketDetails(ticket: any) {
    ticket.availableTickets = this.userCredits.creditsRemaining;
    ticket.userId = this.userProfile.id;
    ticket.disableAutoFlag = false;
    this.selectedTicket = ticket;
    this.prizeDrawingModalOpen = true;
  }

  onPrizeRedeemed(ticket: any) {
    this.getTicketRedemption(ticket);
    this.getLatestData(ticket);
  }

  getLatestData(ticket: any) {
    this.sellerService.getCreditsAvailable().subscribe(
      (data: any) => {
        this.userCredits = data;
        ticket.availableTickets = data.creditsRemaining;
        ticket.disableAutoFlag = false;
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  // To get the list of widgets
  getTicketRedemption(ticket?: any) {
    const params = {
      userId: this.userProfile.id,
    };
    this.sellerService.getTicketRedemption(params).subscribe(
      (data: any) => {
        this.ticketRedemptionData = data.catalogItems;
        this.redeemCredits = true;
        this.redeemIncentives = false;
        if (ticket) {
          const currentTicket = data.catalogItems.find(function (ele: any) {
            return ele.id == ticket.id;
          });
          if (currentTicket) {
            ticket.quarterlyAmountOwned = currentTicket.quarterlyAmountOwned;
          }
        }
      },
      (err: any) => {
        this.errors = err;
      }
    );
  }

  // For coming back to the redeem rewards page.
  showRedeemIncentives() {
    this.redeemIncentives = true;
    this.redeemCredits = false;
  }

  // View initialization method.
  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  // For splitting the data.
  splitData(value: any) {
    if (value) {
      const parseValue = parseFloat(value);
      const newData = parseValue.toLocaleString();
      return newData.toString();
    }
    return value;
  }

  // To change the date format.
  formatDate(date: any) {
    const formatDate = new Date(date.split("T")[0]);
    return `${
      this.months[formatDate.getMonth()]
    } ${formatDate.getDate()}, ${formatDate.getFullYear()}`;
  }

  getCashearnedData() {
    this.sellerService.getCashEarnedData().subscribe((response: any) => {
      if (response) {
        this.cashEarnedData = response;
      }
    });
  }
}
